import React from 'react';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="dark-header">
      <div className="dark-logo" onClick={() => scrollToSection('hero')}>
        <span style={{ 
          fontSize: '24px', 
          fontWeight: 600, 
          color: '#00FFD1',
          cursor: 'pointer',
          letterSpacing: '-0.5px'
        }}>SMART FACTORY CHAIN EIRL </span>
      </div>

      {/* Desktop Navigation */}
      <nav className="dark-nav hidden md:flex">
        <button onClick={() => scrollToSection('servicios')} className="dark-nav-link">Servicios</button>
        <button onClick={() => scrollToSection('casos')} className="dark-nav-link">Casos de Uso</button>
        <button onClick={() => scrollToSection('contacto')} className="dark-nav-link">Contacto</button>
      </nav>

      {/* Mobile Menu Button */}
      <button 
        className="md:hidden" 
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        style={{ color: '#FFFFFF', background: 'none', border: 'none', cursor: 'pointer' }}
      >
        {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
      </button>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="absolute top-20 left-0 w-full bg-black border-t border-white/25 md:hidden">
          <nav className="flex flex-col p-5 gap-4">
            <button onClick={() => scrollToSection('servicios')} className="dark-nav-link text-left">Servicios</button>
            <button onClick={() => scrollToSection('casos')} className="dark-nav-link text-left">Casos de Uso</button>
            <button onClick={() => scrollToSection('contacto')} className="dark-nav-link text-left">Contacto</button>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;